/**
 * Newer TestRail responses paginate under a key (e.g. `projects`, `runs`,
 * `sections`); older ones return a flat array. Normalize to a flat array.
 */
export function unwrap(data, key) {

    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data[key])) return data[key];
    return [];

}
